import { render, staticRenderFns } from "./Salaries.vue?vue&type=template&id=b79f8930&"
import script from "./Salaries.vue?vue&type=script&lang=js&"
export * from "./Salaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b79f8930')) {
      api.createRecord('b79f8930', component.options)
    } else {
      api.reload('b79f8930', component.options)
    }
    module.hot.accept("./Salaries.vue?vue&type=template&id=b79f8930&", function () {
      api.rerender('b79f8930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget/Salaries.vue"
export default component.exports